import React from 'react';
import { TalkToJourneyMessage } from './types';
import { Block, LayoutMode, Section } from '../types';
import { Nullable } from 'src/types/nullable.type';
import { TalkToJourneyBlockMessageIdentifier } from './message-identifier';
import showdown from 'showdown';
import { TalkToJourneySourceBlock } from './source-block';

const convertMarkdownToHTML = (markdown: string) => {
  const converter = new showdown.Converter();
  return converter.makeHtml(markdown);
}

export const TalkToJourneyBlockMessage = ({
  name,
  message,
  onSourceClick,
  layoutMode,
  findBlockByContentUuid,
  findSectionById,
}: {
  name?: Nullable<string>;
  message: TalkToJourneyMessage;
  onSourceClick?: () => void;
  layoutMode: LayoutMode;
  findBlockByContentUuid: (content_uuid: string) => Nullable<Block>;
  findSectionById: (section_id: string) => Nullable<Section>;
}) => {
  return (
    <div className="flex flex-col items-start">
      <div className="flex justify-start shrink-0">
        <TalkToJourneyBlockMessageIdentifier message={message} name={name} />
      </div>
      <div className="flex flex-col space-y-2 pl-8">
        <div>
          {message.role === 'assistant' && message.text ? (
            <div
              dangerouslySetInnerHTML={{
                __html: convertMarkdownToHTML(message.text)
              }} />
          ) : message.text}
        </div>
        <TalkToJourneySourceBlock
          message={message}
          onSourceClick={onSourceClick}
          layoutMode={layoutMode}
          findBlockByContentUuid={findBlockByContentUuid}
          findSectionById={findSectionById}
        />
      </div>
    </div>
  )
}